export default () => ({
  handler: 'relativeUrl',
  data: ({ casinoCategory, lobbySlug }) => `/${lobbySlug}${casinoCategory ? `/category/${casinoCategory}` : ''}`,
});
